<label [for]="id" [ngClass]="['control-label', _labelClass]">{{ label + '&nbsp;:' }}</label>
<div [ngClass]="_fieldClass">
	<multi-extended-filterable-select
		[id]="id"
		[disabled]="disabled"
		[maxNumberOfSelections]="maxNumberOfSelections"
		[preselectionFunction]="isOuvragePreselected"
		[list]="ouvrages"
		[labelGetter]="getOuvrageLabel"
		[categoryList]="parcs"
		[categoryLabelGetter]="getParcLabel"
		[wildcardCategoryLabel]="'... dans tous les parcs choisis du groupement ' + (groupement ? groupement.code + '' : '')"
		[categoryChecker]="checkCategory"
		[reinitCommands]="reinitSubject"
		(selectedItemsChange)="onSelectedOuvragesChange($event)"
		>
	</multi-extended-filterable-select>
</div>